export default __webpack_public_path__ + "static/media/logo.e825d7e8.png";